var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bubble-animation"},[_c('canvas',{ref:"canvas",attrs:{"width":_vm.size.width,"height":_vm.size.height}}),(_vm.tooltipData)?_c('cloud-perfume-tooltip',{style:({top: _vm.tooltipData.y+'px', left: _vm.tooltipData.x+'px'}),attrs:{"meta-data":_vm.tooltipData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }